module.exports = __webpack_public_path__ + "img/background-6.b1f98418.png";